import { Link } from 'react-router-dom';

export const SiteFooter = () => (
  <footer className="py-10 border-t bg-card" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-3">
            <img src="/logo.png" alt="VerdictIQ" className="h-10 w-10 object-contain" />
            <span className="font-serif font-bold text-lg">VerdictIQ</span>
          </div>
          <p className="text-xs text-muted-foreground leading-relaxed">
            AI-powered relationship dispute resolution. Fair verdicts for every argument.
          </p>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.15em] font-semibold mb-3">Product</h4>
          <div className="space-y-2">
            <Link to="/pricing" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-pricing-link">Pricing</Link>
          </div>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.15em] font-semibold mb-3">Legal & Support</h4>
          <div className="space-y-2">
            <Link to="/terms" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-terms-link">Terms of Service</Link>
            <Link to="/privacy" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/contact" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-contact-link">Contact Us</Link>
          </div>
        </div>
      </div>
      <div className="mt-8 pt-6 border-t text-center">
        <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} VerdictIQ. All rights reserved. Fair verdicts for every dispute.</p>
      </div>
    </div>
  </footer>
);
